/* eslint-disable object-shorthand */
const useTraverseTree = () => {
  const insertNode = (tree, folderId, item, isFolder) => {
    if (tree.id === folderId && tree.isFolder) {
      tree.items.unshift({
        id: new Date().getTime(),
        name: item,
        isFolder: isFolder,
        items: [],
        storefiles: []
      });
      return { ...tree };
    }

    const updatedItems = tree.items.map((ob) => {
      return insertNode(ob, folderId, item, isFolder);
    });

    return { ...tree, items: updatedItems };
  };

  const deleteNode = (tree, nodeId) => {
    if (!tree.isFolder) return tree;

    const filteredItems = tree.items.filter(item => item.id !== nodeId);

    const updatedItems = filteredItems.map(item => {
      return deleteNode(item, nodeId);
    });

    return { ...tree, items: updatedItems };
  };

  const renameNode = (tree, nodeId, newName) => {
    if (tree.id === nodeId) {
      tree.name = newName;
      return { ...tree };
    }

    const updatedItems = tree.items.map(item => {
      return renameNode(item, nodeId, newName);
    });

    return { ...tree, items: updatedItems };
  };

  const moveNode = (tree, nodeId, targetFolderId) => {
    let nodeToMove = null;

    const removeNode = (tree) => {
      if (!tree.isFolder) return tree;

      const filteredItems = tree.items.filter(item => {
        if (item.id === nodeId) {
          nodeToMove = item;
          return false;
        }
        return true;
      });

      const updatedItems = filteredItems.map(item => removeNode(item));
      return { ...tree, items: updatedItems };
    };

    const addNode = (tree) => {
      if (tree.id === targetFolderId && tree.isFolder && nodeToMove) {
        tree.items.push(nodeToMove);
        return { ...tree };
      }

      const updatedItems = tree.items.map(item => addNode(item));
      return { ...tree, items: updatedItems };
    };

    const treeWithoutNode = removeNode(tree);
    return addNode(treeWithoutNode);
  };

  return { insertNode, deleteNode, renameNode, moveNode };
};

export default useTraverseTree;
